<div class="position-relative overflow-hidden w-100 h-100 banner-wrapper {{bannerMode}}" >
    
    <div *ngIf="module.banner_video && screenWidth > 1024" class="cursor-wrapper" (mousemove)="onMouseMove($event)" (mouseout)="onMouseOut()" (click)="activateBannerModule()"></div>
    <div *ngIf="module.banner_video && screenWidth > 1024" class="cursor" [ngClass]="{ 'banner-cursor':playVideoButton, 'banner-cursor-pause':!playVideoButton}"></div>

    <div class="banner-slideshow-container w-100 h-100" *ngIf="module"  [ngStyle]="{'background-color':postColor}"
    (swipeleft)="onSwipeLeft()"
    (swiperight)="onSwipeRight()"
    [ngClass]="{
        'banner-left text-left':module.banner_align == 'left',
        'banner-right text-right':module.banner_align == 'right',
        'banner-center text-center':module.banner_align == 'center'
    }">
        <div class="banner-item w-100 h-100" 
        *ngFor="let banner of module.banner_gallery; let j = index" 
         [ngClass]="{'banner-item-active':galleryItemActive == j}"
            [attr.data-button-color]="banner?.title_and_subtitle_color"
         >
         <img (load)="isLoaded()" class="w-100 h-100" src="{{banner?.banner_item}}" alt="" [ngClass]="{'is-loaded': imageIsLoaded }">
            <div *ngIf="i == 0 && banner" class="d-none d-md-block single-item-content-wrapper index-extralarge">
                <h3 class="heading3 animate-content text-uppercase" 
                [ngClass]="{'animate-content-active':videocontentActive,
                        'f-white':banner.title_and_subtitle_color == 'white',
                        'f-darker':banner.title_and_subtitle_color == 'black',
                        'animation-disable': disableTitleAnimation}">{{subtitle}}</h3>
                <h1 class="heading1 font-bold animate-content"
                [ngClass]="{'animate-content-active':videotitleActive,
                            'f-white':banner.title_and_subtitle_color == 'white',
                            'f-darker':banner.title_and_subtitle_color == 'black',
                            'animation-disable': disableTitleAnimation}">{{title}}</h1>
            <!-- <div *ngIf="module.banner_video" class="play-video-button" [ngClass]="{'fade-in':projectIsLoaded}">
                <a class="link1" (click)="activateBannerModule()"
                            [ngClass]="{
                            'link-white': banner.title_and_subtitle_color == 'white',
                            'link-darker' : banner.title_and_subtitle_color == 'black'}" >Watch Video</a>
            </div> -->
            </div>
            <!-- <div *ngIf="i == 0 && banner && module.banner_video" class="d-block d-md-none single-item-content-wrapper index-extralarge">
                <a class="link1-mobile" (click)="activateBannerModule()"
                [ngClass]="{
                'link-white': banner.title_and_subtitle_color == 'white',
                'link-darker' : banner.title_and_subtitle_color == 'black'}" >Watch Video</a>
            </div>  -->
            <div class="d-block d-md-none play-wrapper" *ngIf="i == 0 && banner && module.banner_video">
                <a class="button button-white  button-large" 
                (click)="activateBannerModule()"
                >Play</a>
            </div>
        </div>
        <div class="dots-wrapper gallery-dots-wrapper" *ngIf="module?.banner_gallery.length > 1">
            <a (click)="activeSlide(j); $event.stopPropagation();" class="gallery-dots dark-dots"
              *ngFor="let dots of module?.banner_gallery;  let j = index">
                <div class="dots-inner-wrapper"
                [ngClass]="{'white-dots':module.banner_gallery[galleryItemActive].title_and_subtitle_color == 'white',
                             'dark-dots':module.banner_gallery[galleryItemActive].title_and_subtitle_color == 'black'}" 
                [ngStyle]="{'width': labelwidth +'px'}">
                    <mat-progress-bar *ngIf="galleryItemActive == j" mode="determinate" value="{{width}}"></mat-progress-bar>
                </div>
            </a>
        </div>
    </div>
  
    <app-banner-module-video
        [i]="i"
        #videoitem
        [ngClass]="{'video-active': videoPlaying}"
        [randomImage]="randomImage"
        class="w-100 h-100 module-video"
        *ngIf="module.banner_video"
        [returncolorvalue]=" module.banner_gallery[galleryItemActive].title_and_subtitle_color"
        [returnbuttoncolorvalue]=" module.banner_gallery[galleryItemActive].title_and_subtitle_color"
        [videoid]="module.banner_video"
        [textColor]="getStorageTextColor"
        [subtitle]="subtitle"
        [title]="title"
        [contentAlign]="module.banner_align">
    </app-banner-module-video>

</div>

<div *ngIf="i == 0" class="d-block d-md-none content-wrapper-m">
    <h3 class="heading3 heading-3-m f-darker" 
    [ngClass]="{
        'text-left':module.banner_align == 'left',
        'text-right':module.banner_align == 'right',
        'text-center':module.banner_align == 'center'
    }"> {{subtitle}} </h3>
    <h1 class="heading1 heading-2-3-m font-bold f-darker" 
    [ngClass]="{
        'text-left':module.banner_align == 'left',
        'text-right':module.banner_align == 'right',
        'text-center':module.banner_align == 'center'
    }"> {{title}}</h1>
</div>

<div *ngIf="i == 0" class="d-none overlay-module-container" 
        [ngClass]="{'overlay-active': setOverlayActive, 
                    'd-md-block': screenWidth > 1024 
                   }"
        [ngStyle]="{'top':  -(counter) + 'px'}">
        <img *ngIf="getStorageImage"  class="overlay-container-wrapper" src="{{getStorageImage}}" alt="">
        <div class="single-item-content-wrapper">
            <div class="content-wrapper">
                <h3 class="heading3 animate-content" 
                [ngClass]="{'animate-content-active':videocontentActive,
                          'f-white':getStorageTextColor == 'white',
                          'f-darker':getStorageTextColor == 'black'}">{{subtitle}}</h3>
                <h1 class="heading1 font-bold animate-content" 
                [ngClass]="{'animate-content-active':videotitleActive,
                            'f-white':getStorageTextColor == 'white',
                            'f-darker':getStorageTextColor == 'black'}">{{title}}</h1>
            </div> 
        </div>
</div>
